export const GET_SUMMARY = 'GET_SUMMARY'
export const GET_DETAIL = 'GET_DETAIL'



// WEBPACK FOOTER //
// ./src/containers/TableUsageStatistics/constants.js